import { EntityRoutes } from 'routes/constants';
import { OPT_OUT_COLUMN } from 'UI/constants/sharedColumns';

export const NAMES_COLUMNS = [
  {
    name: 'id',
    label: 'Acivity Id',
    options: {
      sort: false,
      display: 'excluded'
    }
  },
  {
    name: 'nameId',
    label: 'Prospect Id',
    options: {
      sort: false,
      display: 'excluded'
    }
  },
  {
    name: 'activityOutcomeObj',
    label: 'Activity Outcome Object',
    options: {
      sort: false,
      display: 'excluded'
    }
  },
  {
    name: 'activityLogId',
    label: 'Activity Log Id',
    options: {
      sort: false,
      display: 'excluded'
    }
  },
  {
    name: 'activityOutcomeTypeId',
    label: 'Activity Outcome Type Id',
    options: {
      sort: false,
      display: 'excluded'
    }
  },
  {
    name: 'activityLogTypeTitle',
    label: 'Type',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'createdAt',
    label: 'Date',
    options: {
      sort: true,
      display: true,
      renderer: 'date'
    }
  },
  {
    name: 'nameName',
    label: 'Prospect Reached',
    options: {
      sort: true,
      display: true,
      renderer: {
        id: 'linkBuilder',
        config: {
          route: EntityRoutes.ContactProfile,
          idKey: 'id',
          textKey: 'name',
          enableInTabRedirect: true
        }
      }
    }
  },
  {
    name: 'nameStatusTitle',
    label: 'Status',
    options: {
      sort: true,
      display: true
    }
  },
  OPT_OUT_COLUMN,
  {
    name: 'nameEmailVerdict',
    label: 'Email Validation',
    options: {
      sort: false,
      display: true,
      renderer: 'emailStatus'
    }
  },
  {
    name: 'nameEmail',
    label: 'Email',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'nameTitle',
    label: 'Title',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'companyName',
    label: 'Company',
    options: {
      sort: true,
      display: true,
      renderer: {
        id: 'linkBuilder',
        config: {
          route: EntityRoutes.CompanyProfile,
          idKey: 'id',
          textKey: 'name',
          enableInTabRedirect: true
        }
      }
    }
  },
  {
    name: 'industryTitle',
    label: 'Industry',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'specialtyTitle',
    label: 'Specialty',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'subspecialtyTitle',
    label: 'Subspecialty',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'countrySlug',
    label: 'Country',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'stateTitle',
    label: 'State',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'cityTitle',
    label: 'City',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'activityOutcome',
    label: 'Outcome',
    options: {
      sort: true,
      display: false
    }
  },
  {
    name: 'activityOutcomeComments',
    label: 'Comments',
    options: {
      sort: true,
      display: false
    }
  }
];

export const ORDER_BY_OPTIONS = {
  column: 'createdAt',
  direction: 'desc'
};
